import {
  format,
  startOfYear,
  endOfYear,
  subYears,
  subDays,
  subWeeks,
  subMonths,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
} from 'date-fns'
import { fromEntries } from '../utils'

export const TYPES = {
  PRIVATE: { label: '未公開企業' },
  IPO: { label: 'IPO企業' },
}
export const TOTAL_FUNDINGS_OPTIONS = [
  { label: '〜 1千万円', range: { from: null, to: 10 } },
  { label: '1千万円 〜', range: { from: 10, to: null } },
  { label: '1億円 〜', range: { from: 100, to: null } },
  { label: '5億円 〜', range: { from: 500, to: null } },
  { label: '10億円 〜', range: { from: 1000, to: null } },
  { label: '50億円 〜', range: { from: 5000, to: null } },
  { label: '100億円 〜', range: { from: 10000, to: null } },
]
export const VALUATION_OPTIONS = [
  { label: '〜 1千万円', range: { from: null, to: 10 } },
  { label: '1千万円 〜', range: { from: 10, to: null } },
  { label: '1億円 〜', range: { from: 100, to: null } },
  { label: '5億円 〜', range: { from: 500, to: null } },
  { label: '10億円 〜', range: { from: 1000, to: null } },
  { label: '50億円 〜', range: { from: 5000, to: null } },
  { label: '100億円 〜', range: { from: 10000, to: null } },
  { label: '1000億円 〜', range: { from: 100000, to: null } },
]
const today = format(new Date(), 'yyyy-MM-dd')
const startOfThisWeek = format(startOfWeek(new Date()), 'yyyy-MM-dd')
const endOfThisWeek = format(endOfWeek(new Date()), 'yyyy-MM-dd')
const startOfThisMonth = format(startOfMonth(new Date()), 'yyyy-MM-dd')
const endOfThisMonth = format(endOfMonth(new Date()), 'yyyy-MM-dd')
const startOfThisYear = format(startOfYear(new Date()), 'yyyy-MM-dd')
const endOfThisYear = format(endOfYear(new Date()), 'yyyy-MM-dd')
const startOfLastYear = format(
  startOfYear(subYears(new Date(), 1)),
  'yyyy-MM-dd'
)
const endOfLastYear = format(endOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd')
const startOfThisQuarter = format(startOfQuarter(new Date()), 'yyyy-MM-dd')
const endOfThisQuarter = format(endOfQuarter(new Date()), 'yyyy-MM-dd')
const ninetyDaysAgo = format(subDays(new Date(), 90), 'yyyy-MM-dd')
const twelveMonthsAgo = format(
  startOfMonth(subMonths(new Date(), 12)),
  'yyyy-MM-dd'
)
const oneWeekAgo = format(subWeeks(new Date(), 1), 'yyyy-MM-dd')
const oneMonthAgo = format(subMonths(new Date(), 1), 'yyyy-MM-dd')
export const ESTABLISHED_DATE_OPTIONS = [
  { label: '今年', period: { from: startOfThisYear, to: endOfThisYear } },
  { label: '前年', period: { from: startOfLastYear, to: endOfLastYear } },
  { label: '前年から今日まで', period: { from: startOfLastYear, to: today } },
  {
    label: '今四半期',
    period: { from: startOfThisQuarter, to: endOfThisQuarter },
  },
  { label: '過去90日間', period: { from: ninetyDaysAgo, to: today } },
  { label: '過去12ヶ月', period: { from: twelveMonthsAgo, to: today } },
]
export const IPOED_DATE_OPTIONS = [
  { label: '今年', period: { from: startOfThisYear, to: endOfThisYear } },
  { label: '前年', period: { from: startOfLastYear, to: endOfLastYear } },
  { label: '前年から今日まで', period: { from: startOfLastYear, to: today } },
  {
    label: '今四半期',
    period: { from: startOfThisQuarter, to: endOfThisQuarter },
  },
  { label: '過去90日間', period: { from: ninetyDaysAgo, to: today } },
  { label: '過去12ヶ月', period: { from: twelveMonthsAgo, to: today } },
]
export const STATUS_UPDATED_DATE_OPTIONS = [
  { label: '今年', period: { from: startOfThisYear, to: endOfThisYear } },
  { label: '前年', period: { from: startOfLastYear, to: endOfLastYear } },
  { label: '前年から今日まで', period: { from: startOfLastYear, to: today } },
  {
    label: '今四半期',
    period: { from: startOfThisQuarter, to: endOfThisQuarter },
  },
  { label: '過去90日間', period: { from: ninetyDaysAgo, to: today } },
  { label: '過去12ヶ月', period: { from: twelveMonthsAgo, to: today } },
  { label: '1週間より前', period: { from: null, to: oneWeekAgo } },
  { label: '1ヶ月より前', period: { from: null, to: oneMonthAgo } },
  { label: '90日より前', period: { from: null, to: ninetyDaysAgo } },
]
export const LAST_FUNDRAISED_OPTIONS = [
  { label: '今年', period: { from: startOfThisYear, to: endOfThisYear } },
  { label: '前年', period: { from: startOfLastYear, to: endOfLastYear } },
  { label: '前年から今日まで', period: { from: startOfLastYear, to: today } },
  {
    label: '今四半期',
    period: { from: startOfThisQuarter, to: endOfThisQuarter },
  },
  { label: '過去90日間', period: { from: ninetyDaysAgo, to: today } },
  { label: '過去12ヶ月', period: { from: twelveMonthsAgo, to: today } },
]
export const FIRST_INTERVIEW_DATE_OPTIONS = [
  { label: '指定なし', period: { from: null, to: null } },
  { label: '今週', period: { from: startOfThisWeek, to: endOfThisWeek } },
  { label: '今月', period: { from: startOfThisMonth, to: endOfThisMonth } },
  { label: '今年', period: { from: startOfThisYear, to: endOfThisYear } },
  { label: '前年', period: { from: startOfLastYear, to: endOfLastYear } },
  { label: '前年から今日まで', period: { from: startOfLastYear, to: today } },
  {
    label: '今四半期',
    period: { from: startOfThisQuarter, to: endOfThisQuarter },
  },
]
export const INITIAL_SERIES_OPTIONS = {
  NULL: { label: '(空白)' },
  SEED: { label: 'シード' },
  SERIES_A: { label: 'シリーズA' },
  SERIES_B: { label: 'シリーズB' },
  SERIES_C: { label: 'シリーズC' },
  SERIES_D: { label: 'シリーズD' },
  SERIES_E: { label: 'シリーズE' },
  SERIES_F: { label: 'シリーズF' },
  SERIES_G: { label: 'シリーズG' },
}
export const SHAREHOLDER_STATUS_OPTIONS = {
  VC: { label: 'VCあり' },
  PAST_VC: { label: '過去VCあり' },
  NO_VC: { label: 'VCなし' },
  UNKNOWN: { label: 'VC不明' },
  PAST_CVC: { label: '過去事業会社あり' },
  CVC: { label: '事業会社あり' },
  FOREIGN: { label: '外国親会社管理下' },
  PERSONAL: { label: '個人事業' },
  INSTITUTION: { label: '公的機関資金支援あり' },
}
export const ORIGIN_OPTIONS = {
  LOCAL: { label: '地方発' },
  UNIVERSITY: { label: '大学発' },
  PUBLIC_RESEARCH: { label: '公的研究機関発' },
  JV: { label: 'JV' },
  SPIN_OFF_CURVE_OUT: { label: 'スピンオフ/カーブアウト' },
  SPIN_OUT: { label: 'スピンアウト' },
  MBO: { label: 'MBO' },
  STUDENT: { label: '学生起業' },
  MIddLE_HIGH_SCHOOL_STUDENT: { label: '中高生起業' },
  JAPAN_ENTRY: { label: 'JapanEntry' },
  UNIVERSITY_ORIGINATED_DB: { label: '大学発ベンチャーDB' },
}
export const INDUSTRY_OPTIONS = {
  COMMUNICATIONS: { label: '通信・ネットワーキング' },
  COMPUTER_HARDWARE: { label: 'コンピューター - ハードウェア' },
  COMPUTER_SERVICES: { label: 'コンピューター - ITサービス' },
  COMPUTER_SOFTWARE: { label: 'コンピューター - ソフトウェア' },
  SEMICONDUCTORS_ELECTRONICS: { label: '半導体/その他電子部品・製品' },
  BIOTECHNOLOGY: { label: 'バイオテクノロジー' },
  BIOTECHNOLOGY_ICT: { label: 'バイオテクノロジー ICT' },
  HEALTHCARE_RELATED: { label: '医療・ヘルスケア' },
  HEALTHCARE_RELATED_ICT: { label: '医療・ヘルスケア ICT' },
  INDUSTRIAL_ENERGY: { label: '産業・エネルギー' },
  INDUSTRIAL_ENERGY_ICT: { label: '産業・エネルギー ICT' },
  CLEANTECHNOLOGY: { label: '環境関連' },
  CLEANTECHNOLOGY_ICT: { label: '環境関連 ICT' },
  RETAILING_MEDIA: { label: '消費者向けサービス・販売' },
  FINANCIAL: { label: '金融・保険・不動産' },
  FINANCIAL_ICT: { label: '金融・保険・不動産 ICT' },
  BUSINESS: { label: 'ビジネスサービス' },
}
export const MARKET_OPTIONS = {
  TSE_PRIME: { label: '東証プライム' },
  TSE_STANDARD: { label: '東証スタンダード' },
  TSE_GROWTH: { label: '東証グロース' },
  NSE_PREMIUM: { label: '名証プレミア' },
  NSE_MAIN: { label: '名証メイン' },
  NSE_NEXT: { label: '名証ネクスト' },
  SSE_FSE: { label: '札幌・福岡証券取引所' },
  TSE_1ST: { label: '東証一部' },
  TSE_2ND: { label: '東証二部' },
  MOTHERS: { label: '東証Mothers' },
  OSE_1ST: { label: '大証一部' },
  OSE_2ND: { label: '大証二部' },
  NSE_1ST: { label: '名証一部' },
  NSE_2ND: { label: '名証二部' },
  TSE_JASDAQ_STANDARD: { label: '東証JASDAQスタンダード' },
  TSE_JASDAQ_GROWTH: { label: '東証JASDAQグロース' },
  OSE_JASDAQ_STARDARD: { label: 'JASDAQスタンダード' },
  OSE_JASDAQ_GROWTH: { label: 'JASDAQグロース' },
  TOKYO_PRO_MARKET: { label: 'TOKYO PRO Market' },
  NASDAQ: { label: 'NASDAQ' },
  AIM: { label: 'AIM' },
  GRETAI: { label: 'GreTai' },
  AMBITIOUS: { label: '札証アンビシャス' },
  CENTREX: { label: '名証セントレックス' },
  Q_BOARD: { label: '福証Q-BOARD' },
  JASDAQ: { label: '旧ジャスダック' },
  NEO: { label: '旧NEO' },
  HERCULES: { label: '旧大証ヘラクレス' },
}
export const IPO_CATEGORY_OPTIONS = {
  VC_INCLUDED: { label: 'VC対象' },
  VC_EXCLUDED: { label: 'VC対象外' },
  TRADITIONAL_MARKET: { label: '調査対象外' },
  UNKNOWN: { label: '不明' },
}
export const EMPLOYEES_OPTIONS = [
  { label: '〜 10人', range: { from: null, to: 10 } },
  { label: '11人 〜', range: { from: 11, to: null } },
  { label: '51人 〜', range: { from: 51, to: null } },
  { label: '101人 〜', range: { from: 101, to: null } },
  { label: '251人 〜', range: { from: 251, to: null } },
  { label: '501人 〜', range: { from: 501, to: null } },
  { label: '1,001人 〜', range: { from: 1001, to: null } },
]
export const INSTITUTE_OPTIONS = {
  CHIBA_UNIVERSITY: { label: '千葉大学' },
  DENKI_TSUSHIN_UNIVERSITY: { label: '電気通信大学' },
  HOKKAIDO_UNIVERSITY: { label: '北海道大学' },
  KEIO_GIJUKU_UNIVERSITY: { label: '慶應義塾大学' },
  KOBE_UNIVERSITY: { label: '神戸大学' },
  KYOTO_UNIVERSITY: { label: '京都大学' },
  KYUSHU_UNIVERSITY: { label: '九州大学' },
  NAGOYA_UNIVERSITY: { label: '名古屋大学' },
  OSAKA_UNIVERSITY: { label: '大阪大学' },
  RITSUMEIKAN_UNIVERSITY: { label: '立命館大学' },
  SHINSHU_UNIVERSITY: { label: '信州大学' },
  TOHOKU_UNIVERSITY: { label: '東北大学' },
  TOKYO_KOGYO_UNIVERSITY: { label: '東京工業大学' },
  TOKYO_RIKA_UNIVERSITY: { label: '東京理科大学' },
  TOKYO_UNIVERSITY: { label: '東京大学' },
  TSUKUBA_UNIVERSITY: { label: '筑波大学' },
  WASEDA_UNIVERSITY: { label: '早稲田大学' },
  OVERSEAS_UNIVERSITIES: { label: '海外大学' },
  OTHER_NATIONAL_UNIVERSITIES: { label: '国公立大学(その他)' },
  OTHER_PRIVATE_UNIVERSITIES: { label: '私立大学(その他)' },
  OTHER_RESEARCH_INSTITUTES: { label: '公的研究機関発(その他)' },
  RIKEN: { label: '理研' },
  SANSOUKEN: { label: '産総研' },
}

export const RESEARCH_STATUS_CATEGORY = {
  CONTINUED: { label: '調査継続中' },
  FINISHED: { label: '調査終了' },
  OUT_OF_SCOPE: { label: '調査対象外' },
  UNVALUED: { label: '未評価' },
  IMPOSSIBLE: { label: '調査不能' },
}

export const AREA_STATES = [
  {
    label: '北海道・東北地方',
    prefs: [
      '北海道',
      '青森県',
      '岩手県',
      '宮城県',
      '秋田県',
      '山形県',
      '福島県',
    ],
  },
  {
    label: '関東地方',
    prefs: [
      '東京都',
      '神奈川県',
      '埼玉県',
      '千葉県',
      '茨城県',
      '栃木県',
      '群馬県',
    ],
  },
  {
    label: '中部地方',
    prefs: [
      '新潟県',
      '富山県',
      '石川県',
      '福井県',
      '山梨県',
      '長野県',
      '岐阜県',
      '静岡県',
      '愛知県',
    ],
  },
  {
    label: '近畿地方',
    prefs: [
      '三重県',
      '滋賀県',
      '京都府',
      '大阪府',
      '兵庫県',
      '奈良県',
      '和歌山県',
    ],
  },
  {
    label: '中国地方',
    prefs: ['鳥取県', '島根県', '岡山県', '広島県', '山口県'],
  },
  { label: '四国地方', prefs: ['徳島県', '香川県', '愛媛県', '高知県'] },
  {
    label: '九州地方',
    prefs: [
      '福岡県',
      '佐賀県',
      '長崎県',
      '熊本県',
      '大分県',
      '宮崎県',
      '鹿児島県',
      '沖縄県',
    ],
  },
]

// TODO:これ順序保証大丈夫か？
export const STATE_OPTIONS = fromEntries(
  AREA_STATES.map((area) =>
    area.prefs.map((s) => {
      return [s, { label: s }]
    })
  ).reduce((a, b) => [...a, ...b], [])
)

export const COUNTRY_OPTIONS = {
  JPN: { label: '日本' },
  ISL: { label: 'アイスランド' },
  IRL: { label: 'アイルランド' },
  AZE: { label: 'アゼルバイジャン' },
  AFG: { label: 'アフガニスタン' },
  USA: { label: 'アメリカ合衆国' },
  VIR: { label: 'アメリカ領ヴァージン諸島' },
  ASM: { label: 'アメリカ領サモア' },
  ARE: { label: 'アラブ首長国連邦' },
  DZA: { label: 'アルジェリア' },
  ARG: { label: 'アルゼンチン' },
  ABW: { label: 'アルバ' },
  ALB: { label: 'アルバニア' },
  ARM: { label: 'アルメニア' },
  AIA: { label: 'アンギラ' },
  AGO: { label: 'アンゴラ' },
  ATG: { label: 'アンティグア・バーブーダ' },
  AND: { label: 'アンドラ' },
  YEM: { label: 'イエメン' },
  GBR: { label: 'イギリス' },
  IOT: { label: 'イギリス領インド洋地域' },
  VGB: { label: 'イギリス領ヴァージン諸島' },
  ISR: { label: 'イスラエル' },
  ITA: { label: 'イタリア' },
  IRQ: { label: 'イラク' },
  IRN: { label: 'イラン・イスラム共和国' },
  IND: { label: 'インド' },
  IDN: { label: 'インドネシア' },
  WLF: { label: 'ウォリス・フツナ' },
  UGA: { label: 'ウガンダ' },
  UKR: { label: 'ウクライナ' },
  UZB: { label: 'ウズベキスタン' },
  URY: { label: 'ウルグアイ' },
  ECU: { label: 'エクアドル' },
  EGY: { label: 'エジプト' },
  EST: { label: 'エストニア' },
  SWZ: { label: 'エスワティニ' },
  ETH: { label: 'エチオピア' },
  ERI: { label: 'エリトリア' },
  SLV: { label: 'エルサルバドル' },
  AUS: { label: 'オーストラリア' },
  AUT: { label: 'オーストリア' },
  ALA: { label: 'オーランド諸島' },
  OMN: { label: 'オマーン' },
  NLD: { label: 'オランダ' },
  GHA: { label: 'ガーナ' },
  CPV: { label: 'カーボベルデ' },
  GGY: { label: 'ガーンジー' },
  GUY: { label: 'ガイアナ' },
  KAZ: { label: 'カザフスタン' },
  QAT: { label: 'カタール' },
  UMI: { label: '合衆国領有小離島' },
  CAN: { label: 'カナダ' },
  GAB: { label: 'ガボン' },
  CMR: { label: 'カメルーン' },
  GMB: { label: 'ガンビア' },
  KHM: { label: 'カンボジア' },
  MKD: { label: '北マケドニア' },
  MNP: { label: '北マリアナ諸島' },
  GIN: { label: 'ギニア' },
  GNB: { label: 'ギニアビサウ' },
  CYP: { label: 'キプロス' },
  CUB: { label: 'キューバ' },
  CUW: { label: 'キュラソー' },
  GRC: { label: 'ギリシャ' },
  KIR: { label: 'キリバス' },
  KGZ: { label: 'キルギス' },
  GTM: { label: 'グアテマラ' },
  GLP: { label: 'グアドループ' },
  GUM: { label: 'グアム' },
  KWT: { label: 'クウェート' },
  COK: { label: 'クック諸島' },
  GRL: { label: 'グリーンランド' },
  CXR: { label: 'クリスマス島' },
  GRD: { label: 'グレナダ' },
  HRV: { label: 'クロアチア' },
  CYM: { label: 'ケイマン諸島' },
  KEN: { label: 'ケニア' },
  CIV: { label: 'コートジボワール' },
  CCK: { label: 'ココス（キーリング）諸島' },
  CRI: { label: 'コスタリカ' },
  COM: { label: 'コモロ' },
  COL: { label: 'コロンビア' },
  COG: { label: 'コンゴ共和国' },
  COD: { label: 'コンゴ民主共和国' },
  SAU: { label: 'サウジアラビア' },
  SGS: { label: 'サウスジョージア・サウスサンドウィッチ諸島' },
  WSM: { label: 'サモア' },
  STP: { label: 'サントメ・プリンシペ' },
  BLM: { label: 'サン・バルテルミー' },
  ZMB: { label: 'ザンビア' },
  SPM: { label: 'サンピエール島・ミクロン島' },
  SMR: { label: 'サンマリノ' },
  MAF: { label: 'サン・マルタン（フランス領）' },
  SLE: { label: 'シエラレオネ' },
  DJI: { label: 'ジブチ' },
  GIB: { label: 'ジブラルタル' },
  JEY: { label: 'ジャージー' },
  JAM: { label: 'ジャマイカ' },
  GEO: { label: 'ジョージア' },
  SYR: { label: 'シリア・アラブ共和国' },
  SGP: { label: 'シンガポール' },
  SXM: { label: 'シント・マールテン（オランダ領）' },
  ZWE: { label: 'ジンバブエ' },
  CHE: { label: 'スイス' },
  SWE: { label: 'スウェーデン' },
  SDN: { label: 'スーダン' },
  SJM: { label: 'スヴァールバル諸島およびヤンマイエン島' },
  ESP: { label: 'スペイン' },
  SUR: { label: 'スリナム' },
  LKA: { label: 'スリランカ' },
  SVK: { label: 'スロバキア' },
  SVN: { label: 'スロベニア' },
  SYC: { label: 'セーシェル' },
  GNQ: { label: '赤道ギニア' },
  SEN: { label: 'セネガル' },
  SRB: { label: 'セルビア' },
  KNA: { label: 'セントクリストファー・ネイビス' },
  VCT: { label: 'セントビンセントおよびグレナディーン諸島' },
  SHN: { label: 'セントヘレナ・アセンションおよびトリスタンダクーニャ' },
  LCA: { label: 'セントルシア' },
  SOM: { label: 'ソマリア' },
  SLB: { label: 'ソロモン諸島' },
  TCA: { label: 'タークス・カイコス諸島' },
  THA: { label: 'タイ' },
  KOR: { label: '大韓民国' },
  TWN: { label: '台湾（中華民国）' },
  TJK: { label: 'タジキスタン' },
  TZA: { label: 'タンザニア' },
  CZE: { label: 'チェコ' },
  TCD: { label: 'チャド' },
  CAF: { label: '中央アフリカ共和国' },
  CHN: { label: '中華人民共和国' },
  TUN: { label: 'チュニジア' },
  PRK: { label: '朝鮮民主主義人民共和国' },
  CHL: { label: 'チリ' },
  TUV: { label: 'ツバル' },
  DNK: { label: 'デンマーク' },
  DEU: { label: 'ドイツ' },
  TGO: { label: 'トーゴ' },
  TKL: { label: 'トケラウ' },
  DOM: { label: 'ドミニカ共和国' },
  DMA: { label: 'ドミニカ国' },
  TTO: { label: 'トリニダード・トバゴ' },
  TKM: { label: 'トルクメニスタン' },
  TUR: { label: 'トルコ' },
  TON: { label: 'トンガ' },
  NGA: { label: 'ナイジェリア' },
  NRU: { label: 'ナウル' },
  NAM: { label: 'ナミビア' },
  ATA: { label: '南極' },
  NIU: { label: 'ニウエ' },
  NIC: { label: 'ニカラグア' },
  NER: { label: 'ニジェール' },
  ESH: { label: '西サハラ' },
  NCL: { label: 'ニューカレドニア' },
  NZL: { label: 'ニュージーランド' },
  NPL: { label: 'ネパール' },
  NFK: { label: 'ノーフォーク島' },
  NOR: { label: 'ノルウェー' },
  HMD: { label: 'ハード島とマクドナルド諸島' },
  BHR: { label: 'バーレーン' },
  HTI: { label: 'ハイチ' },
  PAK: { label: 'パキスタン' },
  VAT: { label: 'バチカン市国' },
  PAN: { label: 'パナマ' },
  VUT: { label: 'バヌアツ' },
  BHS: { label: 'バハマ' },
  PNG: { label: 'パプアニューギニア' },
  BMU: { label: 'バミューダ' },
  PLW: { label: 'パラオ' },
  PRY: { label: 'パラグアイ' },
  BRB: { label: 'バルバドス' },
  PSE: { label: 'パレスチナ' },
  HUN: { label: 'ハンガリー' },
  BGD: { label: 'バングラデシュ' },
  TLS: { label: '東ティモール' },
  PCN: { label: 'ピトケアン' },
  FJI: { label: 'フィジー' },
  PHL: { label: 'フィリピン' },
  FIN: { label: 'フィンランド' },
  BTN: { label: 'ブータン' },
  BVT: { label: 'ブーベ島' },
  PRI: { label: 'プエルトリコ' },
  FRO: { label: 'フェロー諸島' },
  FLK: { label: 'フォークランド（マルビナス）諸島' },
  BRA: { label: 'ブラジル' },
  FRA: { label: 'フランス' },
  GUF: { label: 'フランス領ギアナ' },
  PYF: { label: 'フランス領ポリネシア' },
  ATF: { label: 'フランス領南方・南極地域' },
  BGR: { label: 'ブルガリア' },
  BFA: { label: 'ブルキナファソ' },
  BRN: { label: 'ブルネイ・ダルサラーム' },
  BDI: { label: 'ブルンジ' },
  VNM: { label: 'ベトナム' },
  BEN: { label: 'ベナン' },
  VEN: { label: 'ベネズエラ・ボリバル共和国' },
  BLR: { label: 'ベラルーシ' },
  BLZ: { label: 'ベリーズ' },
  PER: { label: 'ペルー' },
  BEL: { label: 'ベルギー' },
  POL: { label: 'ポーランド' },
  BIH: { label: 'ボスニア・ヘルツェゴビナ' },
  BWA: { label: 'ボツワナ' },
  BES: { label: 'ボネール、シント・ユースタティウスおよびサバ' },
  BOL: { label: 'ボリビア多民族国' },
  PRT: { label: 'ポルトガル' },
  HKG: { label: '香港' },
  HND: { label: 'ホンジュラス' },
  MHL: { label: 'マーシャル諸島' },
  MAC: { label: 'マカオ' },
  MDG: { label: 'マダガスカル' },
  MYT: { label: 'マヨット' },
  MWI: { label: 'マラウイ' },
  MLI: { label: 'マリ' },
  MLT: { label: 'マルタ' },
  MTQ: { label: 'マルティニーク' },
  MYS: { label: 'マレーシア' },
  IMN: { label: 'マン島' },
  FSM: { label: 'ミクロネシア連邦' },
  ZAF: { label: '南アフリカ' },
  SSD: { label: '南スーダン' },
  MMR: { label: 'ミャンマー' },
  MEX: { label: 'メキシコ' },
  MUS: { label: 'モーリシャス' },
  MRT: { label: 'モーリタニア' },
  MOZ: { label: 'モザンビーク' },
  MCO: { label: 'モナコ' },
  MDV: { label: 'モルディブ' },
  MDA: { label: 'モルドバ共和国' },
  MAR: { label: 'モロッコ' },
  MNG: { label: 'モンゴル' },
  MNE: { label: 'モンテネグロ' },
  MSR: { label: 'モントセラト' },
  JOR: { label: 'ヨルダン' },
  LAO: { label: 'ラオス人民民主共和国' },
  LVA: { label: 'ラトビア' },
  LTU: { label: 'リトアニア' },
  LBY: { label: 'リビア' },
  LIE: { label: 'リヒテンシュタイン' },
  LBR: { label: 'リベリア' },
  ROU: { label: 'ルーマニア' },
  LUX: { label: 'ルクセンブルク' },
  RWA: { label: 'ルワンダ' },
  LSO: { label: 'レソト' },
  LBN: { label: 'レバノン' },
  REU: { label: 'レユニオン' },
  RUS: { label: 'ロシア連邦' },
}

export const CB_LATEST_ROUND_TYPE_OPTIONS = {
  pre_seed: { label: 'Pre-Seed', isOther: false },
  seed: { label: 'Seed', isOther: false },
  series_a: { label: 'Series A', isOther: false },
  series_b: { label: 'Series B', isOther: false },
  series_c: { label: 'Series C', isOther: false },
  series_d: { label: 'Series D', isOther: false },
  series_e: { label: 'Series E', isOther: false },
  series_f: { label: 'Series F', isOther: false },
  series_g: { label: 'Series G', isOther: false },
  series_h: { label: 'Series H', isOther: false },
  series_i: { label: 'Series I', isOther: false },
  series_j: { label: 'Series J', isOther: false },
  series_unknown: { label: 'Series Unknown', isOther: false },
  angel: { label: 'Angel', isOther: false },
  private_equity: { label: 'Private Equity', isOther: false },

  // その他の中に描画するもの
  debt_financing: { label: 'Debt Financing', isOther: true },
  convertible_note: { label: 'Convertible Note', isOther: true },
  grant: { label: 'Grant', isOther: true },
  corporate_round: { label: 'Corporate Round', isOther: true },
  equity_crowdfunding: { label: 'Equity Crowdfunding', isOther: true },
  product_crowdfunding: { label: 'Product Crowdfunding', isOther: true },
  secondary_market: { label: 'Secondary Market', isOther: true },
  post_ipo_equity: { label: 'Post-IPO Equity', isOther: true },
  post_ipo_debt: { label: 'Post-IPO Debt', isOther: true },
  post_ipo_secondary: { label: 'Post-IPO Secondary', isOther: true },
  non_equity_assistance: { label: 'Non-equity Assistance', isOther: true },
  initial_coin_offering: { label: 'Initial Coin Offering', isOther: true },
  undisclosed: { label: 'Undisclosed', isOther: true },
}
